// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PotentialTripsDrawer {
  /* Add a bit of separation between close button and actions .ActionsDropdown
  to prevent accidentally closing the form when trying to open the dropdown and vice-versa;
   */
}
.PotentialTripsDrawer .ActionsDropdown {
  margin-right: 1rem;
}

.PotentialTripsForm .FromManifestSwitch {
  padding: 0.375rem 0.75rem;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.5rem;
  overflow: visible;
}
.PotentialTripsForm .FromManifestSwitch .label {
  flex-grow: 1;
  margin-bottom: 0;
}
.PotentialTripsForm .PULocation .input-group-text,
.PotentialTripsForm .DOLocation .input-group-text {
  width: 80px;
  justify-content: center;
}
.PotentialTripsForm .PULocation .LocationDropdown .Field,
.PotentialTripsForm .DOLocation .LocationDropdown .Field {
  margin: 0.5rem 0 !important;
}
.PotentialTripsForm .DOCity {
  width: 80px;
}
.PotentialTripsForm .DOCity .Dropdown-Input {
  padding-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/Manifests/PotentialTrips/styles.scss"],"names":[],"mappings":"AAAA;EACE;;IAAA;AAGF;AAAE;EACE,kBAAA;AAEJ;;AAGE;EACE,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AAAJ;AAEI;EACE,YAAA;EACA,gBAAA;AAAN;AAKI;;EACE,WAAA;EACA,uBAAA;AAFN;AAKM;;EACE,2BAAA;AAFR;AAME;EACE,WAAA;AAJJ;AAKI;EACE,gBAAA;AAHN","sourcesContent":[".PotentialTripsDrawer {\n  /* Add a bit of separation between close button and actions .ActionsDropdown\n  to prevent accidentally closing the form when trying to open the dropdown and vice-versa;\n   */\n  .ActionsDropdown {\n    margin-right: 1rem;\n  }\n}\n\n.PotentialTripsForm {\n  .FromManifestSwitch {\n    padding: 0.375rem 0.75rem;\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: 0.5rem;\n    overflow: visible;\n\n    .label {\n      flex-grow: 1;\n      margin-bottom: 0;\n    }\n  }\n  .PULocation,\n  .DOLocation {\n    .input-group-text {\n      width: 80px;\n      justify-content: center;\n    }\n    .LocationDropdown {\n      .Field {\n        margin: 0.5rem 0 !important;\n      }\n    }\n  }\n  .DOCity {\n    width: 80px;\n    .Dropdown-Input {\n      padding-right: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
